const code_meteo = {
  0: {
    day: {
      description: "Ensolleillé",
      image: "http://openweathermap.org/img/wn/01d@2x.png",
    },
    night: {
      description: "Clair",
      image: "http://openweathermap.org/img/wn/01n@2x.png",
    },
  },
  1: {
    day: {
      description: "globalement Ensolleillé",
      image: "http://openweathermap.org/img/wn/01d@2x.png",
    },
    night: {
      description: "globalement Clair",
      image: "http://openweathermap.org/img/wn/01n@2x.png",
    },
  },
  2: {
    day: {
      description: "partiellement Nuageux",
      image: "http://openweathermap.org/img/wn/02d@2x.png",
    },
    night: {
      description: "partiellement Nuageux",
      image: "http://openweathermap.org/img/wn/02n@2x.png",
    },
  },
  3: {
    day: {
      description: "Nuageux",
      image: "http://openweathermap.org/img/wn/03d@2x.png",
    },
    night: {
      description: "Nuageux",
      image: "http://openweathermap.org/img/wn/03n@2x.png",
    },
  },
  45: {
    day: {
      description: "Brumeux",
      image: "http://openweathermap.org/img/wn/50d@2x.png",
    },
    night: {
      description: "Brumeux",
      image: "http://openweathermap.org/img/wn/50n@2x.png",
    },
  },
  48: {
    day: {
      description: "Brouillard Givrant",
      image: "http://openweathermap.org/img/wn/50d@2x.png",
    },
    night: {
      description: "Brouillard Givrant",
      image: "http://openweathermap.org/img/wn/50n@2x.png",
    },
  },
  51: {
    day: {
      description: "Légère Bruine",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Légère Bruine",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  53: {
    day: {
      description: "Bruine",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Bruine",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  55: {
    day: {
      description: "Bruine forte",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Bruine forte",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  56: {
    day: {
      description: "Légère Bruine verglaçante",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Légère Bruine verglaçante",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  57: {
    day: {
      description: "Bruine verglaçante",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Bruine verglaçante",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  61: {
    day: {
      description: "Légère Pluie",
      image: "http://openweathermap.org/img/wn/10d@2x.png",
    },
    night: {
      description: "Légère Pluie",
      image: "http://openweathermap.org/img/wn/10n@2x.png",
    },
  },
  63: {
    day: {
      description: "Pluie",
      image: "http://openweathermap.org/img/wn/10d@2x.png",
    },
    night: {
      description: "Pluie",
      image: "http://openweathermap.org/img/wn/10n@2x.png",
    },
  },
  65: {
    day: {
      description: "Pluie Intense",
      image: "http://openweathermap.org/img/wn/10d@2x.png",
    },
    night: {
      description: "Pluie Intense",
      image: "http://openweathermap.org/img/wn/10n@2x.png",
    },
  },
  66: {
    day: {
      description: "Légère Pluie Verglaçante",
      image: "http://openweathermap.org/img/wn/10d@2x.png",
    },
    night: {
      description: "Légère Pluie Verglaçante",
      image: "http://openweathermap.org/img/wn/10n@2x.png",
    },
  },
  67: {
    day: {
      description: "Pluie Verglaçante",
      image: "http://openweathermap.org/img/wn/10d@2x.png",
    },
    night: {
      description: "Pluie Verglaçante",
      image: "http://openweathermap.org/img/wn/10n@2x.png",
    },
  },
  71: {
    day: {
      description: "Légère Neige",
      image: "http://openweathermap.org/img/wn/13d@2x.png",
    },
    night: {
      description: "Légère Neige",
      image: "http://openweathermap.org/img/wn/13n@2x.png",
    },
  },
  73: {
    day: {
      description: "Neige",
      image: "http://openweathermap.org/img/wn/13d@2x.png",
    },
    night: {
      description: "Neige",
      image: "http://openweathermap.org/img/wn/13n@2x.png",
    },
  },
  75: {
    day: {
      description: "Neige Intense",
      image: "http://openweathermap.org/img/wn/13d@2x.png",
    },
    night: {
      description: "Neige Intense",
      image: "http://openweathermap.org/img/wn/13n@2x.png",
    },
  },
  77: {
    day: {
      description: "Neige Grains",
      image: "http://openweathermap.org/img/wn/13d@2x.png",
    },
    night: {
      description: "Neige Grains",
      image: "http://openweathermap.org/img/wn/13n@2x.png",
    },
  },
  80: {
    day: {
      description: "Légère Averse",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Légère Averse",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  81: {
    day: {
      description: "Averse",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Averse",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  82: {
    day: {
      description: "Averse Forte",
      image: "http://openweathermap.org/img/wn/09d@2x.png",
    },
    night: {
      description: "Averse Forte",
      image: "http://openweathermap.org/img/wn/09n@2x.png",
    },
  },
  85: {
    day: {
      description: "Légère Neige Averse",
      image: "http://openweathermap.org/img/wn/13d@2x.png",
    },
    night: {
      description: "Légère Neige Averse",
      image: "http://openweathermap.org/img/wn/13n@2x.png",
    },
  },
  86: {
    day: {
      description: "Neige Averse",
      image: "http://openweathermap.org/img/wn/13d@2x.png",
    },
    night: {
      description: "Neige Averse",
      image: "http://openweathermap.org/img/wn/13n@2x.png",
    },
  },
  95: {
    day: {
      description: "Orage",
      image: "http://openweathermap.org/img/wn/11d@2x.png",
    },
    night: {
      description: "Orage",
      image: "http://openweathermap.org/img/wn/11n@2x.png",
    },
  },
  96: {
    day: {
      description: "Légère Orages avec Grêle",
      image: "http://openweathermap.org/img/wn/11d@2x.png",
    },
    night: {
      description: "Orage modéré avec Grêle",
      image: "http://openweathermap.org/img/wn/11n@2x.png",
    },
  },
  99: {
    day: {
      description: "Orage avec Grêle",
      image: "http://openweathermap.org/img/wn/11d@2x.png",
    },
    night: {
      description: "Orage avec Grêle",
      image: "http://openweathermap.org/img/wn/11n@2x.png",
    },
  },
};
export default code_meteo;
